import {createPostObject} from "./helpers";

export const assetsBaseUrl =
process.env.NODE_ENV === "production" ? "/calculator" : "";

const getApiUrl = (version) => {
  const {hostname} = window.location;
  let api = (version !== 2) ? 'https://api.hypotheker.nl' : 'https://api.hypotheker.nl/v2';

  if (hostname.indexOf('staging') !== -1) {
    api = (version !== 2) ? 'https://api.hypotheker.nl' : 'https://staging-api.hypotheker.nl/v2';
  }

  if (hostname.indexOf('test') !== -1) {
    api = (version !== 2) ? 'https://testapi.hypotheker.nl' : 'https://test-api.hypotheker.nl/v2';
  }

  if (hostname.indexOf('acc') !== -1) {
    api = (version !== 2) ? 'https://acpapi.hypotheker.nl' : 'https://acc-api.hypotheker.nl/v2';
  }

  if (hostname.indexOf('localhost') !== -1) {
    api = (version !== 2) ? 'https://api.hypotheker.nl' : 'https://acc-api.hypotheker.nl/v2';
  }

  return api;
};

export const CanIAffordThisHouseApi = async (data, interest) => {

  if (interest) {
    data.Interest = interest;
  }
  let response = await fetch(
    `${getApiUrl(2)}/calculator/caniaffordthishouse`,
    {
      method: "POST",
      body: JSON.stringify(createPostObject(data, 'caniaffordthishouse')),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      redirect: "follow",
    }
  );

  if (response.status >= 500) {
    return {'error': true };
  }
  return response.json(); // error on 500
};

export const calculateMaximumMortgageByIncomeApi = async (data) => {

  let response = await fetch(
  `${getApiUrl(2)}/calculator/maximummortgagebyincome`,
  {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(createPostObject(data)),
    redirect: "follow",
  }
  );

  if (response.status >= 500) {
    return {'error': true };
  }
  return response.json(); // error on 500
};

export const getNhg = async () => {

  let response = await fetch(
  `${getApiUrl(2)}/nhg`,
  {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  }
  );

  return response.json();
}

export const getMortgageProviders = async (MortgageType, IsNieuwbouw, RenteBasis, RentevastePeriode, EnergyLabel) => {

  const getParamEnergyLabel = EnergyLabel ? (EnergyLabel.value === 'APPPPP') ? 'APPPP' : EnergyLabel.value : '';
  let response = await fetch(
  `${getApiUrl(2)}/interestrates/hypotheekaanbieders?HypotheekVorm=${MortgageType}&IsNieuwbouw=${IsNieuwbouw}&RenteBasis=${RenteBasis}&RentevastePeriode=${RentevastePeriode}&EnergyLabel=${getParamEnergyLabel}`,
  {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  }
  );

  return response.json();
}

export const getMortgageProvider = async (id, isnewbuilding, energyLabel) => {
  //console.log(isnewbuilding)
  let response = await fetch(
  `${getApiUrl(2)}/interestrates/hypotheekaanbieders/${id}?isNewBuilding=${isnewbuilding}&energyLabel=${energyLabel}`,
  {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    }
  }
  );

  return response.json();
}

export const calculateMonthlyCostsByMortgage = async (data, interest, maxMortgageAmount) => {

  if (interest) {
    data.Interest = interest;
  }

  if (maxMortgageAmount) {
    data.maxMortgageAmount = maxMortgageAmount;
  }

  let response = await fetch(
  `${getApiUrl(2)}/calculator/monthlycostsbymortgage`,
  {
    method: "POST",
    body: JSON.stringify(createPostObject(data, 'monthlycostsbymortgage')),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    redirect: "follow"
  }
  );

  if (response.status >= 500) {
    return {'error': true };
  }
  return response.json(); // error on 500
};

export const getBanksApi = async (
{MortgageType, RentevastePeriode, IsNieuwbouw, Woning, EnergyLabel},
{riskClass, isNhg}
) => {
  let RenteBasis = 100;
  if (typeof Woning !== "undefined") {
    if (Woning > 0) {
      RenteBasis = riskClass;
    } else if (isNhg) {
      RenteBasis = 0;
    }
  }

  return await getMortgageProviders(MortgageType, parseInt(IsNieuwbouw) === 2, RenteBasis, RentevastePeriode, EnergyLabel);
};

export const getShortUrl = async (url, addOn) => {

  if (!addOn) {
    addOn = '';
  }
  /*let data = {
    "group_guid": "Bl64hUIxk07",
    "domain": "bit.ly",
    "long_url": url
  }*/

  let data = {
    "groupId": "Be33b2VNMyq",
    "domain": "berekenen.hypotheker.nl",
    "longUrl": `${url}${addOn}`
  }

  let response = await fetch(
  `${getApiUrl(2)}/urlshortening`,
  {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      //Authorization: "Bearer f8c2e48062804025e994e7d98d37e2ad0517812e"
      Authorization: "Bearer b4916c1b36fb25378359c58936862bfc3d1e3d15"
    },
    body: JSON.stringify(data),
  }
  );

  return response.json();
}

export const calculateYearlyIncome = async (data) => {
  let response = await fetch(
  `${getApiUrl(2)}/calculator/calculateyearlyincome`,
  {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  }
  );

  return response.json();
};
export const getSummaryPdf = (data) => {
 return fetch(
  `${getApiUrl(2)}/calculator/pdf`,
  {
    method: "POST",
    mode: "cors",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    xhrFields: {
      responseType: "blob",
    },
    body: JSON.stringify(data),
  })
  .then((response) => response.blob())
  .then((blob) => {
    // Create blob link to download
    const url = window.URL.createObjectURL(new Blob([blob]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `berekening-De-Hypotheker.pdf`);

    // Append to html link element page
    document.body.appendChild(link);

    // Start download
    link.click();

    // Clean up and remove the link
    link.parentNode.removeChild(link);
  });
};

export const sharePdfViaEmail = async (data) => {
  try {
    let response = await fetch(
    `${getApiUrl(2)}/calculator/email`,
    {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });

    //console.log(response)
    if (response.status === 200) {
      return {
        state: 'mailed',
        success: true,
        message: 'Email is verstuurt'
      }
    } else {
      return {
        state: 'mailed',
        success: false,
        message: 'Email is niet verstuurt'
      }
    }
  } catch (e) {

  }

};


// copied
export const calculateYearlyIncomeIndependentApi = async (postData) => {
  const url =
  "https://raadhuys.nodum.io/api/hypotheker-api?apiKey=91da9493217153354c8e954b3ecfb5dbc21f431f" +
  "&ld1=" +
  (Number(postData.ld1) ? postData.ld1 : 0) +
  "&lvu1=" +
  (Number(postData.lvu1) ? postData.lvu1 : 0) +
  "&ov1=" +
  (Number(postData.ov1) ? postData.ov1 : 0) +
  "&sfw1=" +
  (Number(postData.sfw1) ? postData.sfw1 : 0) +
  "&bpga1=" +
  (Number(postData.bpga1) ? postData.bpga1 : 0) +
  "&ld2=" +
  (Number(postData.ld2) ? postData.ld2 : 0) +
  "&lvu2=" +
  (Number(postData.lvu2) ? postData.lvu2 : 0) +
  "&ov2=" +
  (Number(postData.ov2) ? postData.ov2 : 0) +
  "&sfw2=" +
  (Number(postData.sfw2) ? postData.sfw2 : 0) +
  "&bpga2=" +
  (Number(postData.bpga2) ? postData.bpga2 : 0) +
  "&ld3=" +
  (Number(postData.ld3) ? postData.ld3 : 0) +
  "&lvu3=" +
  (Number(postData.lvu3) ? postData.lvu3 : 0) +
  "&ov3=" +
  (Number(postData.ov3) ? postData.ov3 : 0) +
  "&sfw3=" +
  (Number(postData.sfw3) ? postData.sfw3 : 0) +
  "&bpga3=" +
  (Number(postData.bpga3) ? postData.bpga3 : 0);

  let response = await fetch(url, {
    method: "GET",
  });

  return response.json();
};
